import { onMounted, onUnmounted, ref } from 'vue'

/**
 * Reactive preference for reduced motion (accessibility).
 */
export function useReducedMotion(): { prefersReducedMotion: ReturnType<typeof ref<boolean>> } {
  const prefersReducedMotion = ref(false)

  let mq: MediaQueryList | null = null

  const sync = () => {
    prefersReducedMotion.value = mq?.matches ?? false
  }

  onMounted(() => {
    if (typeof window === 'undefined') return
    mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    sync()
    mq.addEventListener('change', sync)
  })

  onUnmounted(() => {
    mq?.removeEventListener('change', sync)
  })

  return { prefersReducedMotion }
}
